(function () {
  const LETTER_PATTERN = /Inicial\s+([A-Z])/i;

  function extractLetter(value) {
    const m = value.match(LETTER_PATTERN);
    return m ? m[1].toUpperCase() : null;
  }

  function isLetterSelect(select) {
    return Array.from(select.options).some(o => extractLetter(o.value));
  }

  function buildPicker(select) {
    if (select.dataset.ioPickerApplied) return;
    select.dataset.ioPickerApplied = 'true';

    const letters = Array.from(select.options)
      .filter(o => o.value && extractLetter(o.value))
      .map(o => ({ letter: extractLetter(o.value), value: o.value }));

    if (!letters.length) return;

    // Hide original select but keep it accessible for form submission
    select.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);';

    const wrapper = document.createElement('div');
    wrapper.className = 'io-picker';

    // Search input
    const inputWrap = document.createElement('div');
    inputWrap.className = 'io-picker__input-wrap';

    const priceMatch = letters[0] && letters[0].value.match(/\(\$?([\d.]+)\)/);
    const price = priceMatch ? '$' + Number(priceMatch[1].replace(/\./g, '')).toLocaleString('es-CO') : null;

    const input = document.createElement('input');
    input.type = 'text';
    input.className = 'io-picker__input';
    input.placeholder = price ? `Buscar letra... ${price}` : 'Escoger una letra (GRATIS!)';
    input.maxLength = 1;
    input.autocomplete = 'off';
    input.spellcheck = false;

    const clearBtn = document.createElement('button');
    clearBtn.type = 'button';
    clearBtn.className = 'io-picker__clear';
    clearBtn.innerHTML = '&times;';
    clearBtn.hidden = true;
    clearBtn.setAttribute('aria-label', 'Limpiar selección');

    inputWrap.appendChild(input);
    inputWrap.appendChild(clearBtn);

    // Letter grid
    const grid = document.createElement('div');
    grid.className = 'io-picker__grid';
    grid.setAttribute('role', 'listbox');

    const btnMap = {};

    letters.forEach(({ letter, value }) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'io-picker__letter';
      btn.textContent = letter;
      btn.dataset.value = value;
      btn.dataset.letter = letter;
      btn.setAttribute('role', 'option');
      btn.setAttribute('aria-selected', 'false');

      btn.addEventListener('click', () => selectLetter(letter, value));
      btnMap[letter] = btn;
      grid.appendChild(btn);
    });

    wrapper.appendChild(inputWrap);
    wrapper.appendChild(grid);
    select.parentNode.insertBefore(wrapper, select);

    function selectLetter(letter, value) {
      // Update select
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));

      // Update input display
      input.value = letter;
      clearBtn.hidden = false;

      // Update button states
      Object.values(btnMap).forEach(b => {
        b.classList.remove('io-picker__letter--selected');
        b.setAttribute('aria-selected', 'false');
      });
      if (btnMap[letter]) {
        btnMap[letter].classList.add('io-picker__letter--selected');
        btnMap[letter].setAttribute('aria-selected', 'true');
      }

      filterGrid('');
    }

    function filterGrid(query) {
      const q = query.trim().toUpperCase();
      letters.forEach(({ letter }) => {
        const btn = btnMap[letter];
        if (!btn) return;
        if (!q || letter === q) {
          btn.classList.remove('io-picker__letter--hidden');
          btn.classList.toggle('io-picker__letter--match', !!q);
        } else {
          btn.classList.add('io-picker__letter--hidden');
          btn.classList.remove('io-picker__letter--match');
        }
      });
    }

    input.addEventListener('input', () => {
      const val = input.value.toUpperCase();
      filterGrid(val);

      // Auto-select if exactly one letter matches
      if (val.length === 1 && btnMap[val]) {
        const matchingOption = letters.find(l => l.letter === val);
        if (matchingOption) selectLetter(val, matchingOption.value);
      }
    });

    input.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        input.value = '';
        clearBtn.hidden = true;
        filterGrid('');
        Object.values(btnMap).forEach(b => {
          b.classList.remove('io-picker__letter--selected');
          b.setAttribute('aria-selected', 'false');
        });
        select.value = '';
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    clearBtn.addEventListener('click', () => {
      input.value = '';
      clearBtn.hidden = true;
      filterGrid('');
      Object.values(btnMap).forEach(b => {
        b.classList.remove('io-picker__letter--selected', 'io-picker__letter--match');
        b.classList.remove('io-picker__letter--hidden');
        b.setAttribute('aria-selected', 'false');
      });
      select.value = '';
      select.dispatchEvent(new Event('change', { bubbles: true }));
      input.focus();
    });

    // Restore state if select already has a value (e.g., page reload)
    const current = select.value ? extractLetter(select.value) : null;
    if (current && btnMap[current]) {
      selectLetter(current, select.value);
    }
  }

  function removeSkeleton() {
    const s = document.getElementById('io-skeleton');
    if (!s) return;
    s.classList.add('io-skeleton--hiding');
    s.addEventListener('transitionend', () => s.remove(), { once: true });
    // Fallback if transition doesn't fire
    setTimeout(() => s.remove(), 400);
  }

  function processContainer() {
    const container = document.getElementById('infiniteoptions-container');
    if (!container) return;
    container.querySelectorAll('select').forEach(sel => {
      if (isLetterSelect(sel)) buildPicker(sel);
    });
  }

  function observeContainer() {
    const container = document.getElementById('infiniteoptions-container');

    if (container && container.children.length) {
      removeSkeleton();
      const observer = new MutationObserver(processContainer);
      observer.observe(container, { childList: true, subtree: true });
      processContainer();
      return;
    }

    // Watch for app to inject/populate the container
    const bodyObserver = new MutationObserver(() => {
      const c = document.getElementById('infiniteoptions-container');
      if (c && c.children.length) {
        bodyObserver.disconnect();
        removeSkeleton();
        const observer = new MutationObserver(processContainer);
        observer.observe(c, { childList: true, subtree: true });
        processContainer();
      }
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeContainer);
  } else {
    observeContainer();
  }
})();
